import { useNavigate } from 'react-router-dom';

const sizes = {
  sm: '32px',
  md: '48px',
  lg: '64px',
  xl: '80px',
  xxl: '120px'
};

function Logo({ size = 'md', clickable = true }) {
  const navigate = useNavigate();
  const height = sizes[size] || sizes.md;

  const handleClick = clickable ? () => navigate('/dashboard') : undefined;

  return (
    <div
      onClick={handleClick}
      style={{ display: 'inline-block', cursor: clickable ? 'pointer' : 'default' }}
    >
      <img
        src="/DopeDash_logo.png"
        alt="Dope Dash"
        style={{ height, objectFit: 'contain', transition: 'transform 0.2s' }}
        onMouseEnter={clickable ? (e) => { e.currentTarget.style.transform = 'scale(1.05)'; } : undefined}
        onMouseLeave={clickable ? (e) => { e.currentTarget.style.transform = 'scale(1)'; } : undefined}
      />
    </div>
  );
}

export default Logo;
